import * as angular from "angular";
import {IController} from "angular";
import {BillingAccountService} from "../../services/billing-account.service";
import {BillingAccountDialogService} from "../../services/billing-account-dialog-service.service";
import {BillingOrderDialogService} from "../../services/billing-order-dialog-service.service";

export class BillingAccountPreferencesCtrl implements IController {

  preferences: any;
  billingAccount: any;
  onChange:Function;

  public billingAccountCopy:any;
  public billingAccountsRef: any;
  public preferencesCopy: any;


  constructor(private $log, private billingOrderDialogService: BillingOrderDialogService, private $billingAccounts, private billingAccountService: BillingAccountService, private billingAccountDialogService: BillingAccountDialogService) {

  }

  $onInit() {
    this.preferencesCopy = angular.copy(this.preferences);
    this.billingAccountsRef = this.$billingAccounts(this.billingAccount.id);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.billingAccount) {
      this.billingAccountCopy = angular.copy(this.billingAccount);
    }
  }

  onEditEdi() {
    this.billingOrderDialogService.editEdiPreferences(this.preferencesCopy)
      .then((updatedPreference) => {
        this.onUpdatePreferences(updatedPreference);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditInvoiceConfiguration($event) {
    this.billingOrderDialogService.editInvoiceConfiguration(this.preferencesCopy, $event)
      .then((updatedPreference) => {
        this.onUpdatePreferences(updatedPreference);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onAddBillingContact(){
    this.billingAccountDialogService.addBillingContact(this.billingAccountCopy)
      .then((billingAccountToUpdate) => {
        this._updateBillingAccount(billingAccountToUpdate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onBillingAccountDetailsEdit(index){
    this.billingAccountDialogService.editBillingContact(this.billingAccountCopy, index)
      .then((billingAccountToUpdate) => {
        this._updateBillingAccount(billingAccountToUpdate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onBillingAccountSettingsEdit(){
    this.billingAccountDialogService.editBillingAccountSettings(this.billingAccountCopy)
      .then((billingAccountToUpdate) => {
        this._updateBillingAccount(billingAccountToUpdate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onUpdatePreferences(updatedPreference) {
    this.billingAccountService.updatePreferences(this.billingAccount.id, updatedPreference)
      .then((updatedPreferences) => {
        this.preferences = angular.copy(updatedPreferences);
        this.preferencesCopy = angular.copy(updatedPreferences);
      })
  }

  private _updateBillingAccount(billingAccount) {
    this.billingAccountService.update(billingAccount.id, billingAccount)
      .then((updatedBillingAccount) => {
        this.onChange({billingAccount: updatedBillingAccount})
      })
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountPreferences', {
    bindings: {
      preferences: '<',
      billingAccount: '<',
      onChange: '&'
    },
    template: require('./billing-account-preferences.html').default,
    controller: BillingAccountPreferencesCtrl
  });
